module.exports = __webpack_public_path__ + "static/media/yellow03.9fa3023f.svg";